import React from 'react'
import { match } from 'ts-pattern'
import InventoryFeedStep from './SoldVehiclePath/InventoryFeedStep'
import VehicleMarketedStep from './SoldVehiclePath/VehicleMarketedStep'
import LeadStep from './SoldVehiclePath/LeadStep'
import SaleStep from './SoldVehiclePath/SaleStep'

type SoldVehiclePathStep = {
  type: 'inventory_feed' | 'vehicle_marketed' | 'lead' | 'sale'
  date: Date
  client_campaign_id?: string
  client_campaign_display_name?: string
  first_imp?: string
  last_imp?: string
  impressions?: number
  clicks?: number
  name?: string
  email?: string
  phone?: string
  inventory_data_provider_name?: string
}

export default function SoldVehiclePathStep({
  path,
}: {
  path: SoldVehiclePathStep
}): JSX.Element {
  return match(path.type)
    .with('inventory_feed', () => <InventoryFeedStep path={path} />)
    .with('vehicle_marketed', () => <VehicleMarketedStep path={path} />)
    .with('lead', () => <LeadStep path={path} />)
    .with('sale', () => <SaleStep path={path} />)
    .exhaustive()
}
